import React from 'react';

import { BuildFailureRateData } from 'src/components/pipelines/hooks/use-build-failure-rate';
import { formatRate } from 'src/components/pipelines/hooks/use-pipelines-timeseries';
import { useIntl } from 'src/hooks/intl';

import { messages } from '../metric-cards/i18n';

import { AverageChart } from './average-chart';
import { averageColorAccessor, inclineValueComparator } from './utils';

/* eslint @typescript-eslint/ban-types: "warn" */
export const AverageBuildFailureRate: React.FC<
  BuildFailureRateData
> = props => {
  const { formatMessage } = useIntl();

  return (
    <AverageChart
      {...props}
      chartConfig={[
        {
          dataKey: 'successRate',
          colorAccessor: averageColorAccessor,
        },
      ]}
      tooltipConfig={[
        {
          dataAccessor: data => formatRate(data?.successRate),
          label: formatMessage(messages.successRate),
        },
        {
          dataAccessor: data => data?.totalBuilds?.toLocaleString(),
          label: formatMessage(messages.count),
        },
      ]}
      chartValueComparator={inclineValueComparator}
      dataFormatter={formatRate}
      chartTitle={formatMessage(messages.buildSuccessRateTitle)}
    />
  );
};
